<template>
  <div class="LineEditor">
    <div>
      <!--v-if="bIsEdit"-->
      <div class="LineEditor bntGroup">
        <base-button @click="GoToEdit(false)" type="primary" class="no-border my-0" simple icon>
          <i class="d-inline-block tim-icons icon-simple-remove"></i>
        </base-button>
      </div>
      <ReChannelEdit :objChannel="masChannels[0]" />
    </div>
  </div>
</template>
<script>
import ReChannelEdit from "src/our_components/ReChannelEdit.vue";

export default {
  name: "line_editor-page",
  components: {
    ReChannelEdit
  },
  data() {
    return {
      ApiData: {},
      masChannels: [],
      bIsEdit: false
    };
  },
  methods: {
    getApiData() {
      this.$GVO
        .ApiCall("GET", { obj: "template" })
        .then(objApi => {
          if (objApi.success === true) {
            if (objApi.data.length > 0) {
              this.ApiData = objApi.data;
            }
          }
        })
        .catch(errorObjApi => console.error(errorObjApi));
    },

    GoToEdit(bGoEdit = true) {
      //this.bIsEdit = bGo;
      if (bGoEdit) {
        this.$router.push({
          path:
            "/data/line/channel/id/" + this.$route.params.channel_id + "/edit"
        });
      } else {
        this.$router.push({ path: "/data/line/" });
      } //передалать
    }
  },
  mounted() {
    this.getApiData();
  }
};
</script>
<style scoped>
.LineEditor.bntGroup {
  position: absolute;
  z-index: 1;
  right: 40px;
}
</style>
